import type { HttpTransport } from "@common/api/transport";
import type { ID } from "@common/types/api";
import type { Note } from "@common/types/Note";
import type { NotePlanting } from "@common/types/Planting";

type SaveNoteParams = {
  id?: number;
  title: string;
  content: string;
  notedOn: string;
  tagIds: number[];
  gardenCropIds: number[];
  images: (string | File)[];
};

const appendList = (formData: FormData, key: string, values: (string | File)[]) => {
  if (values.length === 0) {
    formData.append(key, "");
  }
  values.forEach((value) => formData.append(key, value));
};

const toFormData = ({
  content,
  gardenCropIds,
  images,
  notedOn,
  tagIds,
  title
}: SaveNoteParams) => {
  const formData = new FormData();
  formData.append("note[title]", title);
  formData.append("note[content]", content);
  formData.append("note[noted_on]", notedOn);
  appendList(formData, "note[tag_ids][]", tagIds.map(String));
  appendList(formData, "note[garden_crop_ids][]", gardenCropIds.map(String));
  appendList(formData, "note[images][]", images);
  return formData;
};

export const createNotesApi = (http: HttpTransport) => ({
  destroyNote: (id: ID) => http.del(`/api/notes/${id}`, {}),

  fetchNotePlantings: () => http.get<NotePlanting[]>(`/api/notes/plantings`),

  fetchNotes: (queryParams: {
    startDate?: string;
    endDate?: string;
    searchQuery: string;
  }) => http.get<Note[]>(`/api/notes`, { queryParams }),

  saveNote: (
    params: SaveNoteParams,
    { onUploadProgress }: { onUploadProgress?: (percent: number) => void } = {}
  ) =>
    http.upload<Note>(
      params.id ? `/api/notes/${params.id}` : "/api/notes",
      toFormData(params),
      {
        method: params.id ? "PUT" : "POST",
        onUploadProgress
      }
    )
});
